import React, { Component } from "react";
import PropTypes from "prop-types";
import classnames from "classnames";

import style from "./style.css";

export default class InputMacAddress extends Component {
  handleKeyPress(event) {
    if (event.key === "Enter") {
      const onSubmit = this.props.onSubmit;
      onSubmit();
    }
  }
  render() {
    const { isDisabled } = this.props;
    const finalRootClass = classnames(style.root, this.props.rootClassname);
    return (
      <input
        className={finalRootClass}
        type={this.props.type}
        onChange={this.props.onChange}
        placeholder="00:00:00:00:00"
        defaultValue={this.props.defaultValue}
        onKeyPress={this.handleKeyPress.bind(this)}
        disabled={isDisabled}
      />
    );
  }
}

InputMacAddress.propTypes = {
  onChange: PropTypes.func.isRequired,
  type: PropTypes.string.isRequired,
  rootClassname: PropTypes.string,
  isDisabled: PropTypes.bool.isRequired,
};



// WEBPACK FOOTER //
// ./src/components/Cgn/InputMacAddress/index.js